import { AlertTriangle } from "lucide-react";
import type { FonteCalendario6du } from "../../api/types";

/**
 * Badge de aviso pra dado vindo de heurística em vez do calendário CCEE
 * oficial (Task #61). Aparece quando o ano alvo do próximo 6du ainda não
 * foi importado via scripts/ccee_calendario_import.py.
 *
 * Mesmo padrão visual do IntegrationPendingBadge (turbinho, discreto) mas
 * com tom âmbar/yellow pra distinguir "estimativa" de "aguardando integração".
 */
export function EstimativaBadge({
  ano,
  title,
  fonte,
}: {
  /** Ano não coberto pelo calendário CCEE — usado no label. */
  ano?: number;
  title?: string;
  /** 16/10: `calendario_estimado` = o ano TEM calendário estimado gravado
   * (regra × Zeus) → tooltip próprio. Qualquer outro valor ou ausente = ano
   * sem calendário nenhum → tooltip da heurística. */
  fonte?: FonteCalendario6du;
}) {
  const labelAno = ano ?? new Date().getFullYear();
  const titleEff =
    title ??
    (fonte === "calendario_estimado"
      ? `Datas de ${labelAno} do calendário estimado gravado: regra de dias úteis ` +
        `cruzada com o Zeus. Serão substituídas pelo calendário oficial quando a ` +
        `CCEE o publicar.`
      : `Próximo 6du calculado pela heurística "6º dia útil do mês". Pode divergir em ` +
        `meses com feriado. Para precisão, importar planilha CCEE oficial do ano ${labelAno}.`);
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-amber-200/90 bg-amber-400/10 border border-amber-300/30 px-2 py-0.5 rounded"
      data-testid="estimativa-badge"
      title={titleEff}
    >
      <AlertTriangle size={10} />
      Estimativa — datas do calendário estimado (regra + Zeus); CCEE {labelAno} ainda não publicado
    </span>
  );
}
